import Box from "ds/components/Box";
import useMainNavigationStore from "components/MainNavigation/stores/useMainNavigationStore";
import useMainNavigationFadeTransition from "components/MainNavigation/hooks/useFadeTransition";
import { selectNavigationIsExpanded } from "components/MainNavigation/selectors/navigationState";

import MainNavigationPinnedGroup from "../PinnedItems";
import MainNavigationSearchButton from "../SearchButton";
import styles from "./styles.module.css";
import MainNavigationLogo from "../Logo";
import MainNavigationSettingsButton from "../SettingsButton";
import MainNavigationButtonExpand from "../ButtonExpand";

const MainNavigationHeader = () => {
  const isSidebarExpanded = useMainNavigationStore(selectNavigationIsExpanded);
  const { transitionClasses } = useMainNavigationFadeTransition(!!isSidebarExpanded);

  return (
    <Box
      className={styles.navigationHeader}
      direction="column"
      gap="medium"
      padding="0 0 medium"
      shrink="0"
    >
      <Box justify="between" padding="small 0">
        <MainNavigationLogo />

        <Box gap="small" className={transitionClasses}>
          <MainNavigationSettingsButton />
          {isSidebarExpanded && <MainNavigationButtonExpand />}
        </Box>
      </Box>

      <MainNavigationSearchButton />
      <MainNavigationPinnedGroup />
    </Box>
  );
};

export default MainNavigationHeader;
